"use client";

import {createContext, useContext} from "react";
import type {ConversationMessage} from "@/services/wingman";

/** Follow-up actions stay in the conversation that owns the approval, including in the dock. */
export const WorkflowPublicationContext = createContext<{
   messages: ConversationMessage[];
   disabled: boolean;
   onOpenInEditor?: () => void;
   onTest: (workflowId: string) => Promise<boolean>;
   onFollowUp: (text: string) => Promise<boolean>;
} | null>(null);

export const useWorkflowPublication = () => useContext(WorkflowPublicationContext);
